let KeycloakLib: any;

async function loadKeycloak() {
  if (!KeycloakLib) {
    const mod = await import('keycloak-js');
    KeycloakLib = mod.default;
  }
  return KeycloakLib;
}

const createKeycloak = async () => {
  const Keycloak = await loadKeycloak();

  const serverOrigin = process.env.REACT_APP_IDENTITY;
  const gatewayPort = process.env.REACT_APP_IDENTITY_PORT;
  const portPart =
    process.env.NODE_ENV.includes('development') && gatewayPort
      ? `:${gatewayPort}`
      : '';

  const apiUrl = `${serverOrigin}${portPart}`;
  console.info('[Keycloak init] URL:', apiUrl);

  return new Keycloak({
    url: apiUrl,
    realm: 'grupaPomocnik',
    clientId: 'employee-kiosk-app',
  });
};

// eksportujemy obiekt po inicjalizacji
const keycloakPromise = createKeycloak();
export default keycloakPromise;
